// Load icon fonts on demand: only when the page contains elements that use
// them. Material Symbols Outlined is NOT loaded here; the pinned @font-face
// in layout/theme.liquid already provides it on every page.
(function () {
  'use strict';

  var FONTS = [
    {
      sel: '.material-icons, .material-icons-outlined, .material-icons-round, .material-icons-sharp, .material-icons-two-tone',
      href: 'https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Round|Material+Icons+Sharp|Material+Icons+Two+Tone'
    },
    {
      sel: '.material-symbols-rounded',
      href: 'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL@20..48,300..400,0..1&display=swap'
    },
    {
      sel: '.material-symbols-sharp',
      href: 'https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:opsz,wght,FILL@20..48,300..400,0..1&display=swap'
    }
  ];

  function inject(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

  function load() {
    FONTS.forEach(function (font) {
      if (document.querySelector(font.sel)) inject(font.href);
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(load, { timeout: 3000 });
  } else {
    setTimeout(load, 100);
  }
  document.addEventListener('shopify:section:load', load);
})();
